import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import Cookies from "js-cookie";

const CATEGORIES = [
  "Agriculture",
  "Apparel",
  "Automobiles",
  "Beverages",
  "Construction",
  "Cosmetics",
  "Currencies",
  "Education",
  "Electronics",
  "Food",
  "Government",
  "Media",
  "Organizations",
  "Petroleum",
  "Pharmaceuticals",
];

const FieldLabel = ({ children, required }) => (
  <div
    style={{
      color: "#6b7280",
      fontSize: 11,
      fontWeight: 700,
      letterSpacing: "0.06em",
      textTransform: "uppercase",
      marginBottom: 8,
    }}
  >
    {children}
    {required && <span style={{ color: "#ef4444", marginLeft: 4 }}>*</span>}
  </div>
);

const SectionDivider = ({ label }) => (
  <div
    style={{
      display: "flex",
      alignItems: "center",
      gap: 10,
      margin: "20px 0 16px",
    }}
  >
    <div style={{ flex: 1, height: 1, background: "#f3f4f6" }} />
    <span
      style={{
        fontSize: 11,
        fontWeight: 700,
        color: "#9ca3af",
        letterSpacing: "0.06em",
        textTransform: "uppercase",
      }}
    >
      {label}
    </span>
    <div style={{ flex: 1, height: 1, background: "#f3f4f6" }} />
  </div>
);

const inputStyle = {
  width: "100%",
  backgroundColor: "#fff",
  border: "1.5px solid #e5e7eb",
  borderRadius: 10,
  padding: "10px 14px",
  fontSize: 14,
  color: "#111827",
  outline: "none",
  transition: "border-color 0.15s, box-shadow 0.15s",
};

const focusHandlers = {
  onFocus: (e) => {
    e.target.style.borderColor = "#ff5100";
    e.target.style.boxShadow = "0 0 0 3px rgba(255,81,0,0.1)";
  },
  onBlur: (e) => {
    e.target.style.borderColor = "#e5e7eb";
    e.target.style.boxShadow = "none";
  },
};

const CreateGenuineProduct = ({
  domain,
  show,
  handleClose,
  handleFormSubmit,
}) => {
  const [userId, setUserId] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);

  useEffect(() => {
    setUserId(Cookies.get("userId"));
  }, []);

  const handleFileChange = (event) => {
    const files = Array.from(event.target.files || []);
    if (files.length + selectedImages.length > 8) {
      alert("You can only upload up to 8 images.");
      return;
    }
    setSelectedImages((prev) => [...prev, ...files]);
  };

  const handleRemoveImage = (index) => {
    setSelectedImages((prev) => prev.filter((_, i) => i !== index));
  };

  const createProduct = () => {
    const brand = document.getElementById("brand")?.value || "";
    const category = document.getElementById("category")?.value || "";
    const description = document.getElementById("description")?.value || "";
    const address = document.getElementById("address")?.value || "";
    const price = document.getElementById("price")?.value || "";
    const phone = document.getElementById("phone")?.value || "";
    const whatsapp = document.getElementById("whatsapp")?.value || "";
    const email = document.getElementById("email")?.value || "";
    const website = document.getElementById("website")?.value || "";

    if (!userId) {
      console.error("User not logged in");
      return;
    }

    const formdata = new FormData();
    formdata.append("user", userId);
    formdata.append("brand", brand);
    formdata.append("category", category);
    formdata.append("description", description);
    formdata.append("address", address);
    formdata.append("price", price);
    formdata.append("phone", phone);
    formdata.append("whatsapp", whatsapp);
    formdata.append("email", email);
    formdata.append("website", website);
    formdata.append("country", "Uganda");
    selectedImages.forEach((image) =>
      formdata.append("postimages", image, image.name),
    );

    fetch("/api/genuineProducts", {
      method: "POST",
      body: formdata,
      redirect: "follow",
    })
      .then((res) => res.text())
      .then(() => {
        handleClose();
        handleFormSubmit();
        setSelectedImages([]);
      })
      .catch((error) => console.error(error));
  };

  const remaining = 8 - selectedImages.length;

  return (
    <>
      <style>{`
        .create-genuine-modal .modal-content {
          background: #fff;
          border: 1px solid #e5e7eb;
          border-radius: 18px;
          box-shadow: 0 20px 60px rgba(0,0,0,0.12);
        }
        .create-genuine-modal .modal-header {
          background: #fff;
          border-bottom: 1px solid #f3f4f6;
          border-radius: 18px 18px 0 0;
          padding: 20px 24px 16px;
        }
        .create-genuine-modal .modal-body {
          background: #fff;
          padding: 20px 24px;
        }
        .create-genuine-modal .modal-footer {
          background: #f9fafb;
          border-top: 1px solid #f3f4f6;
          border-radius: 0 0 18px 18px;
          padding: 16px 24px;
        }
        .upload-zone {
          border: 1.5px dashed #d1d5db;
          border-radius: 12px;
          padding: 20px;
          text-align: center;
          cursor: pointer;
          transition: border-color 0.15s, background 0.15s;
          background: #fafafa;
        }
        .upload-zone:hover {
          border-color: #ff5100;
          background: rgba(255,81,0,0.03);
        }
        .genuine-select {
          width: 100%;
          background: #fff;
          border: 1.5px solid #e5e7eb;
          border-radius: 10;
          padding: 10px 36px 10px 14px;
          font-size: 14px;
          color: #111827;
          outline: none;
          appearance: none;
          -webkit-appearance: none;
          cursor: pointer;
          transition: border-color 0.15s, box-shadow 0.15s;
          border-radius: 10px;
        }
        .genuine-select:focus {
          border-color: #ff5100;
          box-shadow: 0 0 0 3px rgba(255,81,0,0.1);
        }
      `}</style>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        dialogClassName="create-genuine-modal"
        style={{ backdropFilter: "blur(3px)" }}
      >
        <Modal.Header closeButton>
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <div
              style={{
                width: 34,
                height: 34,
                borderRadius: 9,
                background: "rgba(255,81,0,0.08)",
                border: "1.5px solid rgba(255,81,0,0.2)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <i
                className="fas fa-shield-alt"
                style={{ color: "#ff5100", fontSize: 13 }}
              />
            </div>
            <div>
              <div style={{ fontWeight: 800, fontSize: 16, color: "#111827" }}>
                Add Genuine Product
              </div>
              <div style={{ fontSize: 12, color: "#9ca3af", marginTop: 1 }}>
                List an authentic product for verification
              </div>
            </div>
          </div>
        </Modal.Header>

        <Modal.Body>
          {/* Product Name */}
          <div>
            <FieldLabel required>Product Name</FieldLabel>
            <input
              type="text"
              id="brand"
              name="brand"
              placeholder="e.g. Hand Sanitizer 500ml"
              style={inputStyle}
              {...focusHandlers}
            />
          </div>

          {/* Category */}
          <div style={{ marginTop: 16 }}>
            <FieldLabel required>Category</FieldLabel>
            <div style={{ position: "relative" }}>
              <select
                id="category"
                name="category"
                defaultValue=""
                className="genuine-select"
              >
                <option
                  value=""
                  disabled
                >
                  Select a category…
                </option>
                {CATEGORIES.map((cat) => (
                  <option
                    key={cat}
                    value={cat}
                  >
                    {cat}
                  </option>
                ))}
              </select>
              <i
                className="fas fa-chevron-down"
                style={{
                  position: "absolute",
                  right: 14,
                  top: "50%",
                  transform: "translateY(-50%)",
                  color: "#9ca3af",
                  fontSize: 12,
                  pointerEvents: "none",
                }}
              />
            </div>
          </div>

          {/* Images */}
          <div style={{ marginTop: 16 }}>
            <FieldLabel>
              Product Images
              <span
                style={{
                  fontWeight: 400,
                  textTransform: "none",
                  marginLeft: 6,
                  fontSize: 11,
                  color: "#9ca3af",
                }}
              >
                {selectedImages.length}/8
              </span>
            </FieldLabel>

            {remaining > 0 && (
              <div
                className="upload-zone"
                onClick={() => document.getElementById("images")?.click()}
              >
                <i
                  className="fas fa-cloud-upload-alt"
                  style={{
                    fontSize: 22,
                    color: "#d1d5db",
                    display: "block",
                    marginBottom: 6,
                  }}
                />
                <div
                  style={{ fontSize: 13, fontWeight: 600, color: "#6b7280" }}
                >
                  {selectedImages.length === 0
                    ? "Click to select images"
                    : "Add more images"}
                </div>
                <div style={{ fontSize: 11, color: "#9ca3af", marginTop: 3 }}>
                  Up to {remaining} more image{remaining !== 1 ? "s" : ""}
                </div>
              </div>
            )}

            <input
              type="file"
              id="images"
              name="images"
              accept="image/*"
              multiple
              onChange={handleFileChange}
              style={{ display: "none" }}
              disabled={selectedImages.length >= 8}
            />

            {selectedImages.length > 0 && (
              <div
                style={{
                  display: "flex",
                  gap: 8,
                  marginTop: 10,
                  overflowX: "auto",
                  paddingBottom: 4,
                  scrollbarWidth: "none",
                }}
              >
                {selectedImages.map((image, index) => (
                  <div
                    key={index}
                    style={{
                      position: "relative",
                      flexShrink: 0,
                      width: 68,
                      height: 68,
                    }}
                  >
                    <img
                      src={URL.createObjectURL(image)}
                      alt={image.name}
                      style={{
                        width: "100%",
                        height: "100%",
                        borderRadius: 10,
                        objectFit: "cover",
                        border: "1.5px solid #e5e7eb",
                      }}
                    />
                    <button
                      type="button"
                      onClick={() => handleRemoveImage(index)}
                      style={{
                        position: "absolute",
                        top: -5,
                        right: -5,
                        width: 20,
                        height: 20,
                        borderRadius: "50%",
                        background: "#dc2626",
                        border: "2px solid #fff",
                        color: "#fff",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        fontSize: 9,
                      }}
                    >
                      <i className="fas fa-times" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </div>

          {/* Description */}
          <div style={{ marginTop: 16 }}>
            <FieldLabel>Description</FieldLabel>
            <textarea
              id="description"
              name="description"
              placeholder="Describe the product"
              rows={3}
              style={{ ...inputStyle, resize: "vertical", minHeight: 80 }}
              {...focusHandlers}
            />
          </div>

          {/* Address */}
          <div style={{ marginTop: 16 }}>
            <FieldLabel>Address</FieldLabel>
            <textarea
              id="address"
              name="address"
              placeholder="Where can this product be found?"
              rows={2}
              style={{ ...inputStyle, resize: "vertical", minHeight: 64 }}
              {...focusHandlers}
            />
          </div>

          {/* Price */}
          <div style={{ marginTop: 16 }}>
            <FieldLabel>Price</FieldLabel>
            <div style={{ position: "relative" }}>
              <input
                type="text"
                id="price"
                name="price"
                placeholder="0"
                style={{ ...inputStyle, paddingRight: 56 }}
                {...focusHandlers}
              />
              <span
                style={{
                  position: "absolute",
                  right: 14,
                  top: "50%",
                  transform: "translateY(-50%)",
                  fontSize: 12,
                  fontWeight: 700,
                  color: "#9ca3af",
                  pointerEvents: "none",
                }}
              >
                UGX
              </span>
            </div>
          </div>

          <SectionDivider label="Contact Info" />

          {/* Phone + WhatsApp row */}
          <div style={{ display: "flex", gap: 10 }}>
            <div style={{ flex: 1 }}>
              <FieldLabel>Phone</FieldLabel>
              <input
                type="text"
                id="phone"
                name="phone"
                placeholder="+256 700 000 000"
                style={inputStyle}
                {...focusHandlers}
              />
            </div>
            <div style={{ flex: 1 }}>
              <FieldLabel>WhatsApp</FieldLabel>
              <input
                type="text"
                id="whatsapp"
                name="whatsapp"
                placeholder="+256 700 000 000"
                style={inputStyle}
                {...focusHandlers}
              />
            </div>
          </div>

          {/* Email + Website row */}
          <div style={{ display: "flex", gap: 10, marginTop: 16 }}>
            <div style={{ flex: 1 }}>
              <FieldLabel>Email</FieldLabel>
              <input
                type="text"
                id="email"
                name="email"
                placeholder="contact@brand.com"
                style={inputStyle}
                {...focusHandlers}
              />
            </div>
            <div style={{ flex: 1 }}>
              <FieldLabel>Website</FieldLabel>
              <input
                type="text"
                id="website"
                name="website"
                placeholder="www.brand.com"
                style={inputStyle}
                {...focusHandlers}
              />
            </div>
          </div>
        </Modal.Body>

        <Modal.Footer>
          <button
            type="button"
            onClick={createProduct}
            style={{
              width: "100%",
              padding: "11px 0",
              borderRadius: 10,
              border: "none",
              background: "linear-gradient(135deg, #c13d00 0%, #ff5100 100%)",
              color: "#fff",
              fontWeight: 700,
              fontSize: 15,
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 9,
            }}
          >
            Add Product
            <i
              className="fas fa-arrow-right"
              style={{ fontSize: 13 }}
            />
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default CreateGenuineProduct;
